import { Alert } from 'antd';
import React from 'react';

export const PageError = ({ message = 'Error', description }) => {
  return (
    <Alert message={message} description={description} type='error' showIcon />
  );
};
